import { Atom, useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { teamOptionsAtom, selectedTeamsAtom } from '@/atoms/filters/highLevel/teams';
import { playerCyclesOrderedAtom, playerTeamsAtom } from '@/atoms/queries/players';
import { TeamLink } from '@/components/navigation/TeamLink';
import { useGetFilteredOptions } from '@/hooks/useGetFilteredOptions';
import { GamesFilterType } from '@/hooks/useGetGamesByFilter';
import { FormattedGame } from '@/types/game';
import { NumberOption } from '@/types/generic';
import { getOrderedTeamOptions } from '@/utils/cycles';
import { RadarFilterSummaryItem } from './RadarFilterSummaryItem';

export const RadarFilterTeamSummary = ({
  filteredGamesDataAtom,
  selectedGamesAtom,
}: {
  filteredGamesDataAtom: Atom<Promise<FormattedGame[]>>;
  selectedGamesAtom: Atom<Promise<NumberOption[]>>;
}) => {
  const { t } = useTranslation('entity');
  const playerCyclesOrdered = useAtomValue(playerCyclesOrderedAtom);
  const playerTeams = useAtomValue(playerTeamsAtom);

  const filteredTeamOptions = useGetFilteredOptions(
    teamOptionsAtom,
    filteredGamesDataAtom,
    selectedGamesAtom,
    GamesFilterType.TEAM,
  );

  const sortedTeamOptions = getOrderedTeamOptions(playerCyclesOrdered, filteredTeamOptions, playerTeams);

  return (
    <RadarFilterSummaryItem
      label={t('team_one')}
      options={sortedTeamOptions}
      selectedOptions={useAtomValue(selectedTeamsAtom)}
      renderOption={({ label, value }) => <TeamLink id={Number(value)} label={label} />}
    />
  );
};
